// @flow
import axios from 'axios';
import getConfigApps from '../config';
import AppsUtil from './AppsUtil';
import RestApiUtil from './RestApiUtil';
import {ANALYTICS} from '@ccxi/ccxi-apps/src/utils/enums';
import {SophiaLocaleMap} from '../constants/appsConstants';

let parsedSophiaRes = [];
const bannerMappings = {
	ccw_all_apps_banners: ANALYTICS.SURFACE_TYPE.ALL_APPS_BANNER, // eslint-disable-line camelcase
	ccw_categories_banners: ANALYTICS.SURFACE_TYPE.CATEGORY_BANNER, // eslint-disable-line camelcase
	CCH_ALL_APPS_BANNERS: ANALYTICS.SURFACE_TYPE.ALL_APPS_BANNER
};

class SophiaUtil {
	async extractCVSEndPointFromSophia(surfaceId: string, locale: string) {
		const productLanguage = SophiaLocaleMap[locale];
		const parseSophiaRes = sophiaRes => sophiaRes.data.surfaces[surfaceId] && sophiaRes.data.surfaces[surfaceId].containers.filter(container => container.dataType === 'URL')[0].data;
		const parseSophiaResPlatform = (sophiaRes, platform) => sophiaRes.data.surfaces[surfaceId] && sophiaRes.data.surfaces[surfaceId].containers.filter(container => container.dataType === 'URL' && container.containerId === platform)[0].data;
		if (!window.adobeIMS || !window.adobeIMS.getUserProfile()) {
			return;
		}
		const servers = getConfigApps('servers');
		try {
			const sophiaRes = await axios.get(`${servers.SOPHIA}?surfaceId=${surfaceId}&productLanguage=${productLanguage}`,{headers: RestApiUtil.getHeaders(true)});
			AppsUtil.sophiaAnalyticsData[bannerMappings[surfaceId]] = {data: sophiaRes.data, surfaceId};
			if (AppsUtil.hasFeature('temp_contentful_to_aem_migration') && surfaceId === 'CCH_ALL_APPS_BANNERS') {
				parsedSophiaRes = [parseSophiaResPlatform(sophiaRes, 1), parseSophiaResPlatform(sophiaRes, 2), parseSophiaResPlatform(sophiaRes, 3)];
			}
			else {
				parsedSophiaRes = [parseSophiaRes(sophiaRes)];
			}
			return parsedSophiaRes;
		}
		catch (err) {
			throw err;
		}
	}
}

export default new SophiaUtil();
